<div class="dialog-header">
  <div class="title-wrapper">
    <h3 mat-dialog-title class="title">
      <!-- TCE-31247: Show orderDisplayId in header -->
      {{ 'orders.orderInfo.orderId' | translate }} {{ orderDetails?.orderDisplayId }}
    </h3>
  </div>
  <button class="print-button"
          mat-icon-button
          (click)="printOrder()"
          [disabled]="isLoading || !hasOrderDetails || !orderDetails"
          [attr.aria-label]="'orders.dashboard.printOrder' | translate"
          matTooltip="{{ 'orders.dashboard.printOrder' | translate }}">
    <i class="tce-icon-printer"></i>
  </button>
</div>

<mat-dialog-content>
  <div class="loading-container" *ngIf="isLoading">
    <txp-loading [color]="loadingColor.COLOR"></txp-loading>
  </div>

  <div class="messages" *ngIf="!isLoading">
    <txp-message data-qa-label="ShowLoadError"
                 *ngIf="showLoadError"
                 [dismissible]="true"
                 [type]="messageType.DANGER"
                 (dismiss)="dismissError()">
        {{ loadErrorMessageKey | translate }}
    </txp-message>
    <txp-message data-qa-label="EmptyOrdersMsg"
                 *ngIf="emptyOrdersMsg"
                 [dismissible]="true"
                 [type]="messageType.DANGER"
                 (dismiss)="dismissError()">
        {{ 'orders.grid.emptyOrdersMsg' | translate }}
    </txp-message>
    <txp-message *ngIf="failedNegateMsg"
                 [dismissible]="true"
                 [type]="messageType.DANGER"
                 (dismiss)="dismissError()">
        {{ 'orders.grid.failedNegateMsg' | translate }}
    </txp-message>
    <txp-message data-qa-label="ShowPrintError"
                 *ngIf="showPrintError"
                 [dismissible]="true"
                 [type]="messageType.DANGER"
                 (dismiss)="dismissError()">
        {{ 'orders.dashboard.printOrderFail' | translate }}
    </txp-message>
    <txp-message data-qa-label="ShowMoveError"
                 *ngIf="showMoveError"
                 [dismissible]="true"
                 [type]="messageType.DANGER"
                 (dismiss)="dismissError()">
        {{ 'orders.dashboard.moveOrderFail' | translate }}
    </txp-message>
  </div>

  <mat-tab-group class="tab-group" *ngIf="!isLoading && orderDetails">
    <mat-tab [label]=" 'orders.orderInfo.orderTab' | translate">
      <div class="tab">
        <div class="content">
          <div class="section">
            <div class="order">
              <div class="label">
                {{ 'orders.orderInfo.externalId' | translate }}
              </div>
              <div class="data">
                <div *ngIf="orderDetails?.orderDisplayId">{{ orderDetails.orderDisplayId }}</div>
              </div>
              <div class="label">
                {{ 'orders.orderInfo.orderIdLabel' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.orderId }}
              </div>
              <div class="label">
                {{ 'orders.orderInfo.aggregatorId' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.externalId || 'N/A' }}
              </div>
              <div class="label">
                {{ 'orders.orderInfo.channelName' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.channelName }}
              </div>
              <div class="label">
                {{ 'orders.orderInfo.subChannel' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.metaData?.orderingChannel ? translateOrderingChannel(orderDetails.metaData.orderingChannel) : orderDetails?.subChannel }}
              </div>
              <div class="label" *ngIf="orderDetails?.metaData?.deviceType">
                {{ 'orders.orderInfo.deviceType' | translate }}
              </div>
              <div class="data" *ngIf="orderDetails?.metaData?.deviceType">
                {{ translateDeviceType(orderDetails.metaData.deviceType) }}
              </div>
            </div>
            <div class="store">
              <div class="label">
                {{ 'orders.orderInfo.storeDetails' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.store?.name }}
                {{ 'orders.orderInfo.storeNumber' | translate }}
                {{ orderDetails?.store?.number }}
                <div>
                  {{ orderDetails?.store?.address?.address1 }}
                </div>
                <div>
                  {{ orderDetails?.store?.address?.address2 }}
                </div>
                <div>
                  {{ orderDetails?.store?.address?.city }}, {{ orderDetails?.store?.address?.state }}
                  {{ orderDetails?.store?.address?.postcode }}
                </div>
              </div>
            </div>
          </div>
          <div class="section">
            <div class="ready-date-time">
              <div class="label">
                {{ 'orders.orderInfo.orderDateTime' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.orderDate }}
              </div>
              <div class="label" *ngIf="orderDetails?.orderProcessingStatus?.toUpperCase() !== 'SCHEDULED'">
                {{ 'orders.orderInfo.readyDateTime' | translate }}
              </div>
              <div class="label" *ngIf="orderDetails?.orderProcessingStatus?.toUpperCase() === 'SCHEDULED'">
                {{ 'orders.orderInfo.scheduledOrderDateTime' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.estimatedTime }}
              </div>
              <div class="label" *ngIf="orderDetails?.orderProcessingStatus?.toUpperCase() === 'OPEN' && orderDetails?.delayedOrder">
                {{ 'orders.orderInfo.delayedOrder' | translate }}
              </div>
              <div class="data" *ngIf="orderDetails?.orderProcessingStatus?.toUpperCase() === 'OPEN' && orderDetails?.delayedOrder">
                {{ 'orders.orderInfo.yes' | translate }}
              </div>
            </div>
            <div class="order-status">
              <div class="label">
                {{ 'orders.orderInfo.orderStatus' | translate }}
              </div>
              <div class="data">
                {{ formatOrderProcessingStatus(orderDetails?.orderProcessingStatus) }}
              </div>
              <div class="label">
                  {{ 'orders.orderInfo.omOrderStatus' | translate }}
              </div>
              <div class="data">
                  {{ orderDetails?.omOrderStatus || 'N/A'}}
              </div>
              <div class="label">
                {{ 'orders.orderInfo.customerStatus' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.customerStatus }}
              </div>
            </div>
          </div>
          <div class="section" *ngIf="orderDetails?.orderProcessingStatus?.toUpperCase() === 'CANCELLED'">
            <div class="cancellation-reason">
              <div class="label">
                {{ 'orders.orderInfo.cancellationReason' | translate }}
              </div>
              <div class="data">
                {{ 'orders.orderInfo.customerFacingReasons.' + customerFacingReasons[orderDetails?.cancellationReason] | translate}}
              </div>
              <div class="label" >
                {{ 'orders.orderInfo.customerFacingReason' | translate }}
              </div>
              <div class="data">
                {{ 'orders.orderInfo.customerFacingReasons.' + customerFacingReasons[orderDetails?.friendlyCancellationReason] | translate }}
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="section grid">
            <div class="aggregator">
              <div class="section-header">
                {{ 'orders.orderInfo.aggregatorDetails' | translate }}
              </div>
              <div class="aggregator-info">
                <div class="aggregator-status">
                  <div class="label">
                    {{ 'orders.orderInfo.aggregatorStatus' | translate }}
                  </div>
                  <div class="data">
                    {{ orderDetails?.aggregatorStatus ? (('orders.grid.filters.aggregatorStatus.' + (orderDetails?.aggregatorStatus | titlecase)) | translate) : 'N/A' }}
                  </div>
                </div>
                <div class="cancellation-reason-field">
                  <div class="label">
                    {{ 'orders.orderInfo.cancellationReasonLabel' | translate }}
                  </div>
                  <div class="data">
                    {{ orderDetails?.cancellationReason ? (('orders.orderInfo.customerFacingReasons.' + customerFacingReasons[orderDetails?.cancellationReason]) | translate) : 'N/A' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="section grid">
            <div class="customer">
              <div class="section-header">
                {{ 'orders.orderInfo.customer' | translate }}
              </div>
              <div class="customer-info">
                <div class="customer-name">
                  <div class="label">
                    {{ 'orders.orderInfo.customerName' | translate }}
                  </div>
                  <div class="data">
                    {{ (orderDetails?.user?.firstName || '') + ' ' + (orderDetails?.user?.lastName || '') }}
                  </div>
                </div>
                <div class="customer-phone">
                  <div class="label">
                    {{ 'orders.orderInfo.customerPhone' | translate }}
                  </div>
                  <div class="data">
                    {{ orderDetails?.user?.phone }}
                  </div>
                </div>
                <div class="customer-email" *ngIf="orderDetails?.user?.email">
                  <div class="label">
                    {{ 'orders.orderInfo.customerEmail' | translate }}
                  </div>
                  <div class="data">
                    {{ orderDetails?.user?.email }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="section grid">
            <div class="payments-section">
              <div class="section-header">
                {{ 'orders.orderInfo.payment' | translate }}
              </div>
            <div class="payment-location">
                    <!-- {{ 'orders.orderInfo.paymentLocation' | translate }} {{ (('orders.orderInfo.' + orderDetails?.paymentDetails?.paymentLocation) | translate ) || '---'
                    }} -->
                    <div class="label">
                        {{ 'orders.orderInfo.paymentLocation' | translate }}
                    </div>
                    <div class="data">
                        {{ (('orders.orderInfo.' + orderDetails?.paymentDetails?.paymentLocation) | translate ) || '---'
                        }}
                    </div>
            </div>

              <!-- Multiple Payments Grid -->
              <div class="payments-grid" *ngIf="orderDetails?.paymentDetails?.payments; else legacyPayment">
                <div class="payment-card" *ngFor="let payment of orderDetails.paymentDetails.payments; trackBy: trackByTransactionId">
                  <div class="payment-info">
                    <div class="payment-method">
                      <div class="label">
                        {{ 'orders.orderInfo.paymentType' | translate }}
                      </div>
                      <div class="data">
                        {{ payment.paymentMethod || '---' }}
                      </div>
                    </div>
                    <div class="payment-amount">
                      <div class="label">
                        {{ 'orders.orderInfo.amount' | translate }}
                      </div>
                      <div class="data">
                        {{ payment.currency ? ('brand.businessInfo.' + payment.currency | translate) : '' }}
                        {{ payment.amount | number:'1.2' }}
                      </div>
                    </div>
                    <div class="payment-status">
                      <div class="label">
                        {{ 'orders.orderInfo.paymentStatus' | translate }}
                      </div>
                      <div class="data">{{ payment.status || '---' }}</div>
                    </div>
                    <div class="payment-card-info" *ngIf="payment.paymentCard">
                      <div class="label">
                        {{ 'orders.orderInfo.cardInfo' | translate }}
                      </div>
                      <div class="data">
                        {{ payment.paymentCard.maskedCardNumber }}
                        ({{ payment.paymentCard.expiryMonth }}/{{ payment.paymentCard.expiryYear }})
                      </div>
                    </div>
                  </div>

                  <!-- Payment Refunds Section -->
                  <div class="payment-refunds" *ngIf="getPaymentRefunds(payment.transactionId).length > 0">
                    <div class="label">
                      {{ 'orders.orderInfo.refunds' | translate }}
                    </div>
                    <ng-container *ngFor="let refund of getPaymentRefunds(payment.transactionId)">
                      <div class="refund-data">
                        <div class="refund-info">
                          <strong>{{ 'orders.orderInfo.refundAmount' | translate }}</strong>
                          {{ 'brand.businessInfo.' + refund.currency | translate }} {{ refund.amount | number:'1.2'}}
                        </div>
                        <div class="refund-info" [title]="refund.reason">
                          <strong>{{ 'orders.orderInfo.refundReason' | translate }}</strong>
                          {{ refund.reason }}
                        </div>
                        <div class="refund-info" [title]="refund.description">
                          <strong>{{ 'orders.orderInfo.refundDescription' | translate }}</strong>
                          {{ refund.description }}
                        </div>
                        <div>
                          <strong>{{ 'orders.orderInfo.refundStatus' | translate }}</strong>
                          {{ refund.status }}
                        </div>
                        <div>
                          <strong>{{ 'orders.orderInfo.refundDate' | translate }}</strong>
                          {{ refund.timestamp | date: 'MM/dd/yyyy hh:mm:ss a' }}
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <!-- Payment Refund Controls -->
                  <div class="payment-refund-controls" *ngIf="refundEnabledForPayment(payment)">
                    <txp-message
                      class="refund-error"
                      *ngIf="paymentRefundErrors.get(payment.transactionId)"
                      [dismissible]="true"
                      [type]="messageType.DANGER"
                      (dismiss)="paymentRefundErrors.set(payment.transactionId, false)">
                      {{ 'orders.orderInfo.refundFailMsg' | translate }}
                    </txp-message>

                    <txp-button
                      *ngIf="!paymentRefundModes.get(payment.transactionId)"
                      [style]="buttonStyle.SECONDARY"
                      (click)="toggleRefundForPayment(payment.transactionId)"
                    >
                      {{ 'orders.orderInfo.refund' | translate }}
                    </txp-button>

                    <div class="refund-container"
                         [formGroup]="paymentForms.get(payment.transactionId)"
                         *ngIf="paymentRefundModes.get(payment.transactionId) && paymentForms.get(payment.transactionId)">
                      <div class="refund-fields">
                        <mat-form-field class="amount">
                          <mat-label>{{ 'orders.orderInfo.refundOrder.amount' | translate }}</mat-label>
                          <input matInput
                                 txpNumbersOnly
                                 min="0"
                                 required
                                 formControlName="amount">
                          <mat-error *ngIf="paymentForms.get(payment.transactionId)?.get('amount')?.errors; let errors">
                            <mat-error *ngIf="errors?.required">
                              {{ 'form.error.required' | translate}}
                            </mat-error>
                            <mat-error *ngIf="errors?.max">
                              {{ 'form.error.maxAmount' | translate: { 'amount': maxRefundValueForPayment(payment) } }}
                            </mat-error>
                          </mat-error>
                        </mat-form-field>

                        <!-- Remaining Amount Display -->
                        <div class="remaining-amount" *ngIf="shouldShowRemainingAmount(payment)">
                          <span class="remaining-label">{{ 'orders.orderInfo.remainingBalance' | translate }}:</span>
                          <span class="remaining-value">
                            {{ payment.currency ? ('brand.businessInfo.' + payment.currency | translate) : '' }}
                            {{ getRemainingAmountForPayment(payment) | number:'1.2' }}
                          </span>
                        </div>

                        <mat-form-field class="reason">
                          <mat-label>{{ 'orders.orderInfo.refundOrder.reason' | translate }}</mat-label>
                          <input matInput
                                 required
                                 formControlName="reason">
                          <mat-error *ngIf="paymentForms.get(payment.transactionId)?.get('reason')?.errors; let errors">
                            <mat-error *ngIf="errors?.required">
                              {{ 'form.error.required' | translate}}
                            </mat-error>
                          </mat-error>
                        </mat-form-field>

                        <mat-form-field class="description">
                          <mat-label>{{ 'orders.orderInfo.refundOrder.description' | translate }}</mat-label>
                          <input matInput
                                 required
                                 formControlName="description">
                          <mat-error *ngIf="paymentForms.get(payment.transactionId)?.get('description')?.errors; let errors">
                            <mat-error *ngIf="errors?.required">
                              {{ 'form.error.required' | translate}}
                            </mat-error>
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="refund-actions">
                        <txp-button
                          [disabled]="paymentRefundingStates.get(payment.transactionId)"
                          [style]="buttonStyle.SECONDARY"
                          (click)="toggleRefundForPayment(payment.transactionId)"
                        >
                          {{ 'orders.orderInfo.refundOrder.cancel' | translate }}
                        </txp-button>

                        <txp-button
                          [loading]="paymentRefundingStates.get(payment.transactionId)"
                          [disabled]="paymentRefundingStates.get(payment.transactionId) || paymentForms.get(payment.transactionId)?.invalid"
                          [style]="buttonStyle.PRIMARY"
                          (click)="handleRefundForPayment(payment.transactionId)"
                        >
                          {{ 'orders.orderInfo.refundOrder.submit' | translate }}
                        </txp-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Legacy Single Payment Display -->
              <ng-template #legacyPayment>
                <div class="legacy-payment">
                  <div class="label">
                    {{ 'orders.orderInfo.paymentType' | translate }}
                  </div>
                  <div class="data">
                    {{ orderDetails?.paymentType || '---' }}
                  </div>
                  <div class="section">
                    <div class="amount">
                      <div class="label">
                        {{ 'orders.orderInfo.amount' | translate }}
                      </div>
                      <div class="data">
                        {{ orderDetails?.channelTotal  ? ('brand.businessInfo.' + data.currency | translate ) : '' }} {{ orderDetails?.channelTotal | number:'1.2'}}
                      </div>
                    </div>
                    <div class="status">
                      <div class="label">
                        {{ 'orders.orderInfo.paymentStatus' | translate }}
                      </div>
                      <div class="data">---</div>
                    </div>
                  </div>
                  <div class="section refunds" *ngIf="orderDetails?.hasRefunds">
                    <div class="label">
                      {{ 'orders.orderInfo.refunds' | translate }}
                    </div>

                    <ng-container *ngFor="let item of orderDetails?.refunds">
                      <div class="refund-data">
                        <div class="refund-info">
                          <strong>
                            {{ 'orders.orderInfo.refundAmount' | translate }}
                          </strong>
                          {{ 'brand.businessInfo.' + item.currency | translate }} {{ item.amount | number:'1.2'}}
                        </div>

                        <div class="refund-info" [title]="item.reason">
                          <strong>
                            {{ 'orders.orderInfo.refundReason' | translate }}
                          </strong>
                          {{ item.reason }}
                        </div>

                        <div class="refund-info" [title]="item.description">
                          <strong>
                            {{ 'orders.orderInfo.refundDescription' | translate }}
                          </strong>
                          {{ item.description }}
                        </div>

                        <div>
                          <strong>
                            {{ 'orders.orderInfo.refundStatus' | translate }}
                          </strong>
                          {{ item.status }}
                        </div>

                        <div>
                          <strong>
                            {{ 'orders.orderInfo.refundDate' | translate }}
                          </strong>
                          {{ item.timestamp | date: 'MM/dd/yyyy hh:mm:ss a' }}
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="divider"></div>
          <div class="section tax-payer-info" *ngIf="orderDetails?.taxPayerInfo">
            <div class="section-header">
              {{ 'orders.orderInfo.taxPayerInfo.customerTaxInfo' | translate }}
            </div>
            <div class="tax-info">
              <div class="tax-section" *ngIf="orderDetails?.taxPayerInfo?.documentType">
                <div class="label">
                  {{ 'orders.orderInfo.taxPayerInfo.taxType' | translate }}
                </div>
                <div class="data">
                  {{ orderDetails?.taxPayerInfo?.documentType?.toUpperCase() || '---' }}
                </div>
              </div>
              <div class="tax-section" *ngIf="orderDetails?.taxPayerInfo?.documentNumber">
                <div class="label">
                  {{ 'orders.orderInfo.taxPayerInfo.taxId' | translate }}
                </div>
                <div class="data">
                  {{ orderDetails?.taxPayerInfo?.documentNumber?.toUpperCase() || '---' }}
                </div>
              </div>
              <div class="tax-section" *ngIf="orderDetails?.taxPayerInfo?.name">
                <div class="label">
                  {{ 'orders.orderInfo.taxPayerInfo.taxPayerName' | translate }}
                </div>
                <div class="data">
                  {{ (orderDetails?.taxPayerInfo?.name || '---') }}
                </div>
              </div>
              <div class="tax-section" *ngIf="orderDetails?.taxPayerInfo?.address">
                <div class="label">
                  {{ 'orders.orderInfo.taxPayerInfo.address' | translate }}
                </div>
                <div class="data">
                  {{ orderDetails?.taxPayerInfo?.address || '---' }}
                </div>
              </div>
            </div>
          </div>
          <div class="divider" *ngIf="orderDetails?.taxPayerInfo"></div>
          <div class="section">

            <div class="order-details">
                <div class="section-header">
                    {{ 'orders.orderInfo.orderDetails' | translate }}
                </div>

                <div class="items">
                    <!-- Loop through grouped items by guestName -->
                    <div *ngFor="let guestName of groupedItems | keyvalue">
                        <!-- Display Guest Name if present -->
                        <div *ngIf="guestName.key !== 'default'" class="guest-name">
                            {{ guestName.key }}
                        </div>

                        <!-- Loop through items for the current guest -->
                        <ng-template #itemRecursion let-items="items" let-top="top">
                            <div [ngClass]="{ item: top, 'nested-item': !top }" *ngFor="let item of items">
                                <div class="item-container">
                                    <div class="description">
                                        {{ item.quantity }} x
                                        {{ item?.description }}
                                        <txp-badge *ngIf="item.hidden" [type]="badgeType.NEW">
                                            {{ 'orders.orderInfo.modifierHidden' | translate }}
                                        </txp-badge>
                                    </div>
                                    <div class="value">
                                        {{ item?.price | number:'1.2'}}
                                    </div>
                                </div>
                                <div *ngIf="item?.instructions" class="label instructions">
                                    {{ 'orders.orderInfo.note' | translate }} {{ item?.instructions || '---' }}
                                </div>
                                <ng-template [ngTemplateOutlet]="itemRecursion"
                                             [ngTemplateOutletContext]="{ items: item?.items }">
                                </ng-template>
                            </div>
                        </ng-template>

                        <ng-template [ngTemplateOutlet]="itemRecursion"
                                     [ngTemplateOutletContext]="{ items: $any(guestName.value), top: true }">
                        </ng-template>

                        <!-- Subtotal for Guest -->
                        <div *ngIf="guestName.key !== 'default'" class="subtotal">
                            <div class="description">
                                {{ 'orders.orderInfo.subtotal' | translate }}
                            </div>
                            <div class="value">
                                {{ calculateSubtotal($any(guestName.value)) | number:'1.2' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Delivery Instructions -->
                <div class="label">
                    {{ 'orders.orderInfo.deliveryInstructions' | translate }}
                </div>
                <div class="data">
                    {{ orderDetails?.deliveryInstructions || '---' }}
                </div>

                <!-- Order Instructions -->
                <div class="label">
                  {{ 'orders.orderInfo.orderInstructions' | translate }}
                </div>
                <div class="data">
                    {{ orderDetails?.orderInstructions || '---' }}
                </div>

                <!-- Subtotal, Tax, Tip, and Total -->
                <div class="subtotal">
                    <div class="description">
                        {{ 'orders.orderInfo.subtotal' | translate }}
                    </div>
                    <div class="value">
                        {{ orderDetails?.subtotal | number:'1.2' }}
                    </div>
                </div>
                <div class="tax">
                    <div class="description">
                        {{ 'orders.orderInfo.tax' | translate }}
                    </div>
                    <div class="value">
                        {{ orderDetails?.tax | number:'1.2' }}
                    </div>
                </div>
                <ng-container *ngIf="orderDetails?.channelName === 'CONSUMER-API'">
                    <ng-container *ngIf="orderDetails?.tips?.length; else legacyTip">
                        <div class="tip-group" *ngFor="let tip of orderDetails.tips">
                            <div class="tip">
                                <div class="description">
                                    {{ 'orders.orderInfo.tip' | translate }}
                                    <txp-badge [type]="tip.type === 'Delivery' ? badgeType.PRIMARY : badgeType.INFO">
                                        {{ 'orders.orderInfo.tipTypes.' + tip.type | translate }}
                                    </txp-badge>
                                </div>
                                <div class="value">
                                    {{ tip.amount | number:'1.2' }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #legacyTip>
                        <div class="tip">
                            <div class="description">
                                {{ 'orders.orderInfo.tip' | translate }}
                            </div>
                            <div class="value">
                                {{ orderDetails?.tip || '0' | number:'1.2' }}
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
                <div class="total">
                    <div class="description">
                        {{ 'orders.orderInfo.total' | translate }}
                    </div>
                    <div class="value">
                        {{ orderDetails?.channelTotal
                        ? ('brand.businessInfo.' + data.currency | translate)
                        : '' }}
                        {{ orderDetails?.channelTotal | number:'1.2' }}
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]=" 'orders.orderInfo.deliveryTab' | translate" [labelClass]="!orderDetails?.deliveryDetails ? 'disabled': ''">
      <div class="tab">
        <div class="content">
          <div class="section">
            <div class="column">
              <div class="label">
                {{ 'orders.orderInfo.deliveryStatus' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.deliveryDetails?.jobStatus || '---' }}
              </div>
            </div>
            <div class="column">
              <div class="label">
                {{ 'orders.orderInfo.consumerStatus' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.deliveryDetails?.friendlyJobStatus || '---' }}
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="section">
            <div class="section-header">
              {{ 'orders.orderInfo.driverDetails' | translate }}
            </div>
          </div>
          <div class="section">
            <div class="column">
              <div class="label">
                {{ 'orders.orderInfo.driverName' | translate }}
              </div>

              <div class="data">
                {{ orderDetails?.deliveryDetails?.driverName || '---' }}
              </div>

              <div class="label">
                {{ 'orders.orderInfo.deliveryProvider' | translate }}
              </div>

              <div class="data">
                {{ orderDetails?.deliveryDetails?.deliveryProvider || '---' }}
              </div>

              <div class="label">
                {{ 'orders.orderInfo.latitude' | translate }}
              </div>

              <div class="data">
                {{ orderDetails?.deliveryDetails?.latitude || '---' }}
              </div>

              <div class="label">
                {{ 'orders.orderInfo.message' | translate }}
              </div>

              <div class="data">
                {{ orderDetails?.deliveryDetails?.longitude || '---' }}
              </div>

              <div class="label">
                {{ 'orders.orderInfo.trackingUrl' | translate }}
              </div>

              <div class="data">
                {{ orderDetails?.deliveryDetails?.trackingUrl || '---' }}
              </div>
            </div>

            <div class="column">
              <div class="label">
                {{ 'orders.orderInfo.dropoffEta' | translate }}
              </div>

              <div class="data">
                {{ orderDetails?.deliveryDetails?.dropoffEta || '---' }}
              </div>

              <div class="label">
                {{ 'orders.orderInfo.vehicleName' | translate }}
              </div>

              <div class="data">
                {{ orderDetails?.deliveryDetails?.vehicleName || '---' }}
              </div>

              <div class="label">
                {{ 'orders.orderInfo.vehicleType' | translate }}
              </div>

              <div class="data">
                {{ orderDetails?.deliveryDetails?.vehicleType || '---' }}
              </div>

              <div class="label">
                {{ 'orders.orderInfo.longitude' | translate }}
              </div>

              <div class="data">
                {{ orderDetails?.deliveryDetails?.longitude || '---' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]=" 'orders.orderInfo.checkInTab' | translate" [labelClass]="!orderDetails?.deliveryDetails ? 'disabled': ''" *ngIf="orderDetails?.fulfillmentInfo?.vehicleDetails">
      <div class="tab">
        <div class="content">
          <div class="section">
            <div class="vehicleMaker">
              <div class="label">
                {{ 'orders.grid.curbsideCheckIn.make' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.fulfillmentInfo?.vehicleDetails?.make }}
              </div>
              <div class="label">
                {{ 'orders.grid.curbsideCheckIn.model' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.fulfillmentInfo?.vehicleDetails?.model }}
              </div>
              <div class="label">
                {{ 'orders.grid.curbsideCheckIn.part' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.fulfillmentInfo?.vehicleDetails?.part }}
              </div>
            </div>
            <div class="vehicleDetails">
              <div class="label">
                {{ 'orders.orderInfo.vehicleType' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.fulfillmentInfo?.vehicleDetails?.vehicleType }}
              </div>
              <div class="label">
                {{ 'orders.grid.curbsideCheckIn.color' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.fulfillmentInfo?.vehicleDetails?.color }}
              </div>
              <div class="label">
                {{ 'orders.orderInfo.licensePlate' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.fulfillmentInfo?.vehicleDetails?.licensePlate }}
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="section wrapped">
            <div class="vehicleLocation">
              <div class="section-header">
                {{ 'orders.grid.curbsideCheckIn.vehicleLocation' | translate }}
              </div>
              <div class="label">
                {{ 'orders.grid.curbsideCheckIn.location' | translate }}
              </div>
              <div class="data">
                {{ 'orders.grid.curbsideCheckIn.' + orderDetails?.fulfillmentInfo?.vehicleDetails?.vehicleLocation?.type | translate }}
              </div>
              <div class="label">
                {{ 'orders.orderInfo.notes' | translate }}
              </div>
              <div class="data">
                {{ orderDetails?.fulfillmentInfo?.vehicleDetails?.vehicleLocation?.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions *ngIf="!isLoading">
  <txp-button
    data-qa-label="MoveToNextStatusButton"
    *ngIf="canMoveToNextStatus"
    [loading]="isMoving"
    [disabled]="isMoving || isLoading"
    [style]="buttonStyle.PRIMARY"
    (click)="moveToNextStatus()"
  >
    {{ getNextStatusDisplayName() }}
  </txp-button>
  <txp-button
    data-qa-label="CancelOrderButton"
    *ngIf="isOrderUiCancelable()"
    [loading]="isCancellingOrder"
    [disabled]="isCancellingOrder || isLoading"
    [style]="buttonStyle.PRIMARY"
    [primaryColor]="'#e53935'"
    (click)="handleCancelOrder()"
    class="cancel-order-button"
  >
    {{ 'orders.orderInfo.cancelOrder' | translate }}
  </txp-button>
  <txp-button
    data-qa-label="CloseButton"
    [disabled]="isLoading"
    [style]="buttonStyle.SECONDARY"
    (click)="handleClose()"
  >
    {{ 'form.button.close' | translate }}
  </txp-button>

  <!-- TODO: re-enable when we're ready for refund/cancel -->
  <txp-button
    class="negateOrder"
    data-qa-label="CancelButton"
    *ngIf="false && orderDetails?.isCancelable"
    [disabled]="negationStatus !== undefined"
    [loading]="negationStatus === 'loading'"
    [style]="buttonStyle.NOBACKGROUND"
    (click)="handleNegateOrder()"
  >
    {{
      (negationStatus !== 'cancelled'
        ? 'orders.orderInfo.negateOrder.cancel'
        : 'orders.orderInfo.cancelled'
      ) | translate
    }}
  </txp-button>
  <!-- TODO: re-enable when we're ready for refund/cancel -->
  <txp-button
    class="negateOrder"
    data-qa-label="RefundButton"
    *ngIf="false && !orderDetails?.isCancelable && !orderDetails?.hasRefunds"
    [disabled]="negationStatus !== undefined"
    [loading]="negationStatus === 'loading'"
    [style]="buttonStyle.NOBACKGROUND"
    (click)="handleNegateOrder()"
  >
    {{
      (negationStatus !== 'refunded'
        ? 'orders.orderInfo.negateOrder.refund'
        : 'orders.orderInfo.refunded'
      ) | translate
    }}
  </txp-button>
</mat-dialog-actions>

<txp-order-pdf></txp-order-pdf>
